namespace BlockPuzzle {
    export enum WindowHeadingBackplateType {
        SILVER = 0,
        GOLD = 1
    }
}